import {FC} from 'react'

export const ExsportiaAccRectBg: FC = () => (
  <svg
    width='124'
    height='228'
    viewBox='0 0 124 228'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M14.7689 11.8941C11.2176 -0.232592 17.4924 -13.0675 29.2435 -17.713L102.78 -46.7842C116.158 -52.0729 131.188 -44.7248 135.231 -30.9192V-30.9192C138.782 -18.7925 132.508 -5.95766 120.757 -1.31212L47.2199 27.7591C33.842 33.0478 18.8118 25.6997 14.7689 11.8941V11.8941Z'
      stroke='#00D576'
      strokeWidth='3'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M3.10486 83.8462C-0.374945 71.9636 5.60167 59.3592 17.0041 54.5333L131.01 6.28213C144.439 0.598448 159.822 7.89234 163.92 21.887V21.887C167.4 33.7696 161.423 46.374 150.021 51.1999L36.0148 99.4511C22.5856 105.135 7.20318 97.8409 3.10486 83.8462V83.8462Z'
      stroke='#FFA700'
      strokeWidth='3'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M69.9113 125.396C66.385 113.731 72.2695 101.291 83.5245 96.6183L121.005 81.0565C133.971 75.6727 148.751 82.6643 152.814 96.1036V96.1036C156.34 107.769 150.456 120.209 139.201 124.882L101.721 140.444C88.754 145.827 73.974 138.836 69.9113 125.396V125.396Z'
      stroke='#ED3163'
      strokeWidth='3'
    />
  </svg>
)
